<template>
  <div class="">
    <search-group title="" :multipleLines="false" :inline="true" :span="24" :btnOffset="18" :btnSpan="6" @search="findData" @clear="clearValue">
      <Row :gutter="16" class="mb16">
        <Col span="5">
          <Select placeholder="项目名称" v-model="searchData.projectFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input class="block" v-model="searchData.stockNum"  @keyup.enter.native="findData" placeholder="房间号"/>
        </Col>
        <Col span="5">
          <Select placeholder="设备名称" v-model="searchData.projectFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
      </Row>
      <Row :gutter="16" class="mb16">
        <Col span="5">
          <Select placeholder="工单状态" v-model="searchData.status">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in orderStatus" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input class="block" v-model="searchData.stockNum" placeholder="工单号"/>
        </Col>
      </Row>

    </search-group>
  </div>
</template>

<script>
  // import SearchGroup from 'components/SearchGroup/index';
  import { getDeviceType} from "api/smartWorkOrder"

  export default {
    components: {
      // SearchGroup
    },
    props:{
      projectList:{
        type:Array,
        default:''
      },
    },
    watch: {
    },
    data() {
      return {
        searchData: {
          "projectFid": '',
          "stockNum": '',
          limit: 10,
          page: 1,
          status:'',
        },
        orderStatus:[]
      }
    },
    methods: {
      getDeviceInfo(){
        getDeviceType()
        .then(res=>{
          this.orderStatus = res.data.orderStatus;
        })
      },
      findData() {
        this.$emit('findData', this.searchData)
      },
      clearValue() {
        this.searchData = {
          "projectFid": "",
          "stockNum": '',
          limit: 10,
          page: 1,
        }
        this.$emit('clear')
      }
    },
    created() {
      this.getDeviceInfo();
      this.searchData.projectFid = this.projectList[0].value;
      this.$emit('findData',this.searchData)
    }
  }
</script>
<style scoped>
  .flex {
    display: block;

  }
  .search-wrapper{
    padding: 24px  0 !important;

  }

  .shortcut a {
    display: inline-block;
    padding: 10px 20px;
    font-weight: bold;
    color: #444444;
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }

</style>
